import React from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"
import type { PNImageProps } from "@bounce/web-components"
import { Button, HeroContainer, grayBlurDataUrl, imgixCroppedHeroImage } from "@bounce/web-components"

import { SearchBar } from "./SearchBar"
import { Breadcrumbs } from "@/components/Generic/Breadcrumbs/Breadcrumbs"
import type { CityLink } from "@/libs/bounce/cities"
import type { Breadcrumb } from "@/types"

import background from "@/assets/img/default_hero_2.png"

type Props = {
  image?: PNImageProps["src"]
  title?: React.ReactNode
  cities?: CityLink[]
  subtitle?: React.ReactNode
  breadcrumbs: Breadcrumb[]
  className?: string
  cta?: {
    label: string
    href: string
  }
}

export const Hero = ({ title, subtitle, image, cities, breadcrumbs, className, cta }: Props) => {
  const { t } = useTranslation("marketing-generic")
  const bounceGlobals = useBounceGlobalValues()

  return (
    <HeroContainer
      image={image || background}
      placeholder="blur"
      fallbackBlurDataURL={grayBlurDataUrl}
      imgixParams={{ ...imgixCroppedHeroImage }}
      className={className}>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="pb-5" />
      <h1 className="title1 mb-3 mt-1 break-words md:mb-3.5 lg:mb-5">
        {title || t("screen.guidesScreen.heroTitle", "Discover your next destination")}
      </h1>
      <p className="subtitle">
        {subtitle ||
          t("screen.guidesScreen.heroSubtitleV2", "More than {{numGuides}} Guides to help you plan your next trip.", {
            numGuides: bounceGlobals.numGuides,
          })}
      </p>
      {cta && (
        <Button href={cta.href} color="primary" className="mt-11 w-full md:w-fit xl:mt-16">
          {cta.label}
        </Button>
      )}
      {cities && <SearchBar cities={cities} className="mt-8 md:mt-12 md:max-w-[512px]" />}
    </HeroContainer>
  )
}
